import {t} from 'i18next';
import IndexOverView from '../IndexingOverview/IndexingOverview';
import AurBreadcrumb from '../../common/aur-breadcrumb/AurBreadCrumb';
import IndexingBanner from '../IndexManagement/IndexingBanner';
import {useSelector} from 'react-redux';
import {RootState} from '../../../redux/store';
import {Box} from '@mui/material';
import {useState} from 'react';
import AurLoadingIndicator from '../../common/aur-loading-indicator/AurLoadingIndictor';
import { EciHomePageTabs } from '../../../constants/constants';

const NLPIndexOverView = () => {
  const breadCrumbItems = [
    {
      label: t('eca.ecaHomepage.coreEciHome'),
      path: `/eci-home-page?tab=${EciHomePageTabs.ECI_OVERVIEW}`,
    },
    {
      label: t('ecaIndexing.manageIndexes'),
      path: '/indexmanagement',
    },
    {
      label: t('ecaIndexing.nlpIndex'),
    },
  ];
  const [reqLoading] = useState<boolean>(false);

  const indexing = useSelector(
    (state: RootState) => state.indexesBanner.indexBannerData
  );

  const indexDetails = useSelector(
    (state: RootState) => state.indexes.indexData
  );

  return (
    <div className="index-main-container">
      <div className="index-banner-container">
        {indexing?.showIndexBanner ? (
          <IndexingBanner message={indexing?.message} />
        ) : null}
      </div>
      <Box
        data-testid="breadcrumb-container"
        className={indexing?.showIndexBanner ? '' : 'empty-index'}
      >
        <AurBreadcrumb items={breadCrumbItems} />
      </Box>
      <IndexOverView title={indexDetails?.ele?.name} />
      <AurLoadingIndicator overlay={true} isOpen={reqLoading} />
    </div>
  );
};

export default NLPIndexOverView;
